const carouselItems = [
  {
    title: '年度重磅：2024娱乐圈塌房大盘点',
    desc: '从年初到年末，那些让人意想不到的塌房事件，一文带你回顾这一年的惊天大瓜...',
    tag: '年度专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20collage%20of%20newspaper%20headlines%20and%20abstract%20shapes%20in%20warm%20crimson%20and%20gold%20tones%2C%20investigative%20journalism%20theme%2C%20high%20contrast%20lighting%2C%20editorial%20photography%20style%2C%20dark%20sophisticated%20mood%2C%20layered%20texture%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '深扒网红经济：流量背后的资本游戏',
    desc: '揭秘MCN机构的运作链条，看资本如何批量制造网红、操控粉丝经济...',
    tag: '深度调查',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20boardroom%20with%20digital%20screens%20showing%20data%20in%20warm%20crimson%20and%20amber%20lighting%2C%20mysterious%20financial%20atmosphere%2C%20high%20contrast%20shadows%2C%20editorial%20style%2C%20dark%20sophisticated%20background&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '选秀十年：那些被操纵的梦想与人生',
    desc: '从超女到创造营，选秀节目背后的资本运作与暗箱操作全纪录...',
    tag: '系列报道',
    imageUrl: 'https://readdy.ai/api/search-image?query=Theater%20stage%20with%20dramatic%20spotlight%20and%20long%20shadows%2C%20warm%20crimson%20and%20gold%20tones%2C%20mysterious%20performance%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography%2C%20dark%20theatrical%20mood%2C%20empty%20stage&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '品牌危机管理：代言翻车后的24小时',
    desc: '当明星代言人突然塌房，品牌方如何在黄金24小时内紧急止损...',
    tag: '商业解密',
    imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20crisis%20room%20with%20dramatic%20warm%20lighting%2C%20abstract%20brand%20logos%20fading%2C%20crimson%20and%20amber%20tones%2C%20mysterious%20business%20atmosphere%2C%20high%20contrast%2C%20editorial%20style%2C%20dark%20sophisticated%20background&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '粉丝经济黑产链：你的热爱正在被收割',
    desc: '揭秘数据造假、黄牛产业链、粉头集资跑路等粉丝经济背后的灰色地带...',
    tag: '独家揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20of%20connections%20and%20nodes%20in%20warm%20crimson%20and%20gold%2C%20mysterious%20dark%20web%20aesthetic%2C%20high%20contrast%20lighting%2C%20cyber%20theme%2C%20editorial%20photography%20style%2C%20sophisticated%20atmosphere&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1300px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          焦点深扒
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑精选深度专题，带你深入事件核心
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.imageUrl}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group block bg-background-50 rounded-xl border border-secondary-200/60 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-secondary-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-[11px] font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}